require('./login.less');

var pageConfig = window.pageConfig;
var ajax = require('@enhancer/fe-util-ajax');
var login = require('./login.html');
var locale = require('../../i18n');
var util = require('../../app/util');
var app = require('../../app/app');
var needValidate = !!window.EnhancerCaptcha;

var callbackUrl = util.getUrlParam('callbackUrl');
var validateObj = null;
var ssoUrl = util.getUrlParam('ssoUrl'); ///


function init() {
  var html = login({
    locale: locale(),
    domain0: `//${location.hostname.replace(/^[^.]+/, 'i')}`
  });
  $('.user-center-wrapper').append(html);



  function checkUserName(ele, next) {
    var val = ele.val().trim();
    if (util.isEmail(val) || util.isMobile(val)) {
      ele.removeClass('error');
      next && next();
    } else {
      ele.next('label').text(locale('accountInvalid'));
      ele.addClass('error');
    }
  }

  function checkPassword(ele, next) {
    var val = ele.val();
    if (util.isPassword(val)) {
      ele.removeClass('error');
      next && next();
    } else {
      ele.next('label').text(locale('passwordLength'));
      ele.addClass('error');
    }
  }

  function checkCaptcha(ele, next) {
    if (!validateObj) {
      next({});
      return
    }
    var data = validateObj.getValidate()
    if (data) {
      ele.removeClass('error');
      next && next(data);
    } else {
      ele.next('label').text(locale('captchaEmpty'));
      ele.addClass('error');
    }
  }
  $('#account').blur(function() {
    var self = this;
    setTimeout(function () {
      checkUserName($(self));
    }, 500);
  }).focus(function() {
    $(this).removeClass('error');
  });
  $('#password').blur(function() {
    var self = this;
    setTimeout(function () {
      checkPassword($(self));
    }, 500);
  }).focus(function() {
    $(this).removeClass('error');
  }).on('keydown', function (e) {
    if (e.keyCode === 13) {
      $('.login-form button[type=submit]').click();
    }
  });

  var submitting = false
  $('.login-form button[type=submit]').click(function(e) {
    e.preventDefault();
    checkUserName($('#account'), function() {
      checkPassword($('#password'), function() {
        checkCaptcha($('#captcha'), function(data) {
          data.account = $.trim($('#account').val());
          data.password = $.trim($('#password').val());
          if (submitting) {
            return
          }
          submitting = true;
          ajax({
            url: '/api/login',
            type: 'POST',
            data: data
          }, function(res) {
            submitting = false;
            if (res.success) {
              var suffix = (location.hostname.match(/io|cc|local$/) || ['cc'])[0];
              doRedirect(callbackUrl || `//i.enhancer.${suffix}/profile`, ssoUrl);
            } else {
              if (res.code === 1009) {
                if (!validateObj) {
                  submitting = true;
                  initValidate(function() {
                    submitting = false;
                  });
                }
              } else {
                if (validateObj && validateObj.captchaObj) {
                  validateObj.captchaObj.reset();
                }
                util.show(res.message, 'error');
              }
            }
          }, function() {
            submitting = false;
          });
        })
      });
    });
  });

  function doRedirect(callbackUrl, ssoUrl) {
    callbackUrl = decodeURIComponent(callbackUrl || '');
    if (1/*!ssoUrl*/) {
      window.location.href = callbackUrl
      return;
    }

    ssoUrl = decodeURIComponent(ssoUrl || '');
    var token = util.getCookie('token');
    var nickname = util.getCookie('username');
    var uid = util.getCookie('uid');
    if (token && nickname && uid) {
      ajax({
        url: ssoUrl,
        data: {
          token: token,
          nickname: nickname,
          uid: uid
        },
        dataType: 'jsonp'
      },function(res) {
        if (res.success) {
          setTimeout(function() { /////
            window.location.href = callbackUrl
          }, 2000)
        } else {
          console.log(res);
        }
      });
    } else {
      console.error('no token nickname or uid');
    }
  }


  if (callbackUrl) {
    $('.register a').each(function() {
      var url = $(this).prop('href');
      $(this).prop('href', url + '?callbackUrl=' + encodeURI(callbackUrl))
    });
  }


  function laodEnhancerCaptcha(cb) {
    if (window.EnhancerCaptcha) {
      cb();
    } else {
      util.getScript('//assets.enhancer.io/vendor/geetest/all/gt.js', cb);
    }
  }

  function initValidate(cb) {
    laodEnhancerCaptcha(function() {
      validateObj = new window.EnhancerCaptcha({
        geetest: {
          product: 'popup',
          lang: decodeURIComponent(util.getCookie('lang') || ''),
          width: "320px"
        },
        ready: function() {
          validateObj.captchaObj.onSuccess(function() {
            $('#captcha').parent().find('.error').removeClass('error');
          });
        }
      });
      validateObj.render();
      cb && cb();
    })
  }

  if (needValidate) {
    initValidate();
  }

  var errorMsg = $('#error').text();
  if (errorMsg) {
    util.show(errorMsg, 'error')
  }
}

init();
//setTimeout( , 20);


// WEBPACK FOOTER //
// ./src/pages/login/login.js